export default __webpack_public_path__ + "static/media/apex_logo_256.68d8142c.png";